import { useTranslation } from 'react-i18next';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { Spinner } from '@platform/ui';
import { useWorkspaceMeta } from '../../shell/useWorkspaceMeta';
import { SysNote } from '../system/SysNote';
import { SystemPage } from '../system/SystemPage';
import { useCustomizationScope } from '../system/useCustomizationScope';
import { LayoutGridCard } from './layout/LayoutGridCard';
import { LayoutOrderCard } from './layout/LayoutOrderCard';
import { LayoutPreviewCard } from './layout/LayoutPreviewCard';
import { LayoutWidthsCard } from './layout/LayoutWidthsCard';
import { useFieldLayout } from './layout/useFieldLayout';
import './customize.css';

/**
 * «Розміщення полів» (прототип v4 settings › layout): «Сітка» (одиниця поля, дві колонки груп від, довгий варіант вибору), «Порядок груп»,
 * «Типова ширина за типом поля» і «Перегляд». Глобально — налаштування платформи («Скинути до типових»), у просторі — перевизначення лише
 * для нього («Використовувати глобальні налаштування»); кожна зміна зберігається одразу (useFieldLayout).
 */
export function CustLayoutPage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const { workspace } = useWorkspaceMeta(ws);
  const global = useCustomizationScope(ws).scope === 'global';
  const state = useFieldLayout(ws, global);
  if (!state.loaded) return <Spinner />;
  const card = { layout: state.layout, base: state.base, canEdit: state.canEdit, onSave: state.save };
  const actions = (
    <>
      {state.overridden && state.canEdit && <button type="button" className="sp-btn cu-head-btn" onClick={state.useGlobal}>{t('sysCust.layout.useGlobal')}</button>}
      {state.changed && state.canEdit && <button type="button" className="sp-btn sp-btn--danger cu-head-btn" onClick={() => { if (window.confirm(t('sysCust.layout.resetConfirm'))) state.resetDefaults(); }}>{t('sysCust.layout.reset')}</button>}
    </>
  );
  return (
    <SystemPage className="cu-layoutpage" title={t('sysPages.sections.layout')} sub={global ? t('sysCust.layout.subGlobal') : t('sysCust.layout.subWs', { ws: workspace?.name ?? '' })} actions={actions}>
      {!state.canEdit && <SysNote>{t(global ? 'sysCust.layout.onlyAdmin' : 'sysCust.layout.noRights')}</SysNote>}
      <div className="cu-layout-top">
        <LayoutGridCard {...card} />
        <LayoutOrderCard {...card} />
      </div>
      <LayoutWidthsCard {...card} global={global} />
      <LayoutPreviewCard layout={state.layout} />
    </SystemPage>
  );
}
